import {
  SocketIOActions,
  SocketIOState,
  SocketIOMutations,
  SocketIOGetters,
  IIOResourceUpdateData
} from "./types";
import { DefineActions } from "vuex-type-helper";
import store from "@/store";
import { maybeParseJSON } from "@/helpers/maybeParseJSON";

export function doQuoteSocketLogic(payload: IIOResourceUpdateData) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, prefer-const
  const {
    quoteId,
    ratingId,
    retries = 0,
    workerMakeRatingMaxRetry
  } = maybeParseJSON(payload.data);

  if (!quoteId || !ratingId) {
    throw new Error("Missing quote or rating ID");
  }

  const editingQuote = store.state.quote["editing"];
  const maxRetries = store.state.quote["workerMakeRatingMaxRetry"];
  if (editingQuote && editingQuote._id === quoteId) {
    const stringifyRatingId = ratingId.toString();
    const socketRatingIds = store.state.quote["socketRatingIds"];

    if (!socketRatingIds.includes(stringifyRatingId) || retries !== 0) {
      store.dispatch("quote/getQuote", quoteId);
      store.commit("quote/ADD_RATING_ID", stringifyRatingId);
      if (!maxRetries) {
        store.commit("quote/SET_MAX_RATING_PAYLOAD", workerMakeRatingMaxRetry);
      }
    }
  }
}

export function doAuthenticationSocketLogic(payload: IIOResourceUpdateData) {
  //if loginStatusKey has changed then another use logged in with the same credentials so show alert
  const [userId, loginStatusKey] = payload.resourceId.split("-");
  const getCurrentUser = store.getters["auth/getCurrentUser"];
  if (
    getCurrentUser &&
    getCurrentUser._id === userId &&
    localStorage.getItem("loginStatusKey") !== loginStatusKey
  ) {
    store.commit("app/SET_STATE", {
      key: "showLoggedOutModal",
      value: true
    });
  }
}

export function doSettingsSocketLogic(payload: IIOResourceUpdateData) {
  if (payload.reason === "updated") {
    store.dispatch("auth/init");
  }
}

export function doCommunicationSocketLogic(payload: IIOResourceUpdateData) {
  const data = maybeParseJSON(payload.data);
  store.commit("communication/ADD_COMMUNICATION_EVENT", data);
}

export function doSocketLogic(payload: IIOResourceUpdateData) {
  const { resourceType = "" } = payload;
  switch (resourceType) {
    case "quote":
      doQuoteSocketLogic(payload);
      break;
    case "authentication":
      doAuthenticationSocketLogic(payload);
      break;
    case "settings":
      doSettingsSocketLogic(payload);
      break;
    case "agent":
      doCommunicationSocketLogic(payload);
      break;
    default:
      throw `Invalid resource type ${resourceType}`;
    // break;
  }
}

export const actions: DefineActions<
  SocketIOActions,
  SocketIOState,
  SocketIOMutations,
  SocketIOGetters
> = {
  async socket_ioResourceUpdate({}, payload) {
    doSocketLogic(payload);
  }
};
